import React, { lazy } from "react";
import { HomePage } from "@/pages/home/home-page";
import { StubPage } from "@/pages/stub/stub-page";

const SignInPage = lazy(() => import("@/pages/auth/sign-in-page").then(module => ({ default: module.SignInPage })));
const SignUpPage = lazy(() => import("@/pages/auth/sign-up-page").then(module => ({ default: module.SignUpPage })));
const ForgotPasswordPage = lazy(() => import("@/pages/auth/forgot-password-page").then(module => ({ default: module.ForgotPasswordPage })));
const ResetPasswordPage = lazy(() => import("@/pages/auth/reset-password-page").then(module => ({ default: module.ResetPasswordPage })));
const ResetSentPage = lazy(() => import("@/pages/auth/reset-sent-page").then(module => ({ default: module.ResetSentPage })));
const ConfirmEmailPage = lazy(() => import("@/pages/auth/confirm-email-page").then(module => ({ default: module.ConfirmEmailPage })));
const UserSetupPage = lazy(() => import("@/pages/auth/user-setup-page").then(module => ({ default: module.UserSetupPage })));
const AboutPage = lazy(() => import("@/pages/content/about-page").then(module => ({ default: module.AboutPage })));
const CartPage = lazy(() => import("@/pages/checkout/cart-page").then(module => ({ default: module.CartPage })));
const AccountSettingsPage = lazy(() => import("@/pages/account/account-settings-page").then(module => ({ default: module.AccountSettingsPage })));
const ProductDetailsPage = lazy(() => import("@/pages/catalog/product-details-page").then(module => ({ default: module.ProductDetailsPage })));
const ProductListPage = lazy(() => import("@/pages/catalog/product-list-page").then(module => ({ default: module.ProductListPage })));
const ShippingDetailsPage = lazy(() => import("@/pages/checkout/shipping-details-page").then(module => ({ default: module.ShippingDetailsPage })));
const AddressFormPage = lazy(() => import("@/pages/checkout/address-form-page").then(module => ({ default: module.AddressFormPage })));
const AddressesPage = lazy(() => import("@/pages/checkout/addresses-page").then(module => ({ default: module.AddressesPage })));
const OrdersPage = lazy(() => import("@/pages/orders/orders-page").then(module => ({ default: module.OrdersPage })));
const OrderDetailsPage = lazy(() => import("@/pages/orders/order-details-page").then(module => ({ default: module.OrderDetailsPage })));
const ConfirmationPage = lazy(() => import("@/pages/checkout/confirmation-page").then(module => ({ default: module.ConfirmationPage })));
const PaymentPage = lazy(() => import("@/pages/checkout/payment-page").then(module => ({ default: module.PaymentPage })));
const CategoriesPage = lazy(() => import("@/pages/catalog/categories-page").then(module => ({ default: module.CategoriesPage })));
const NotificationsPage = lazy(() => import("@/pages/account/notifications-page").then(module => ({ default: module.NotificationsPage })));
const DriverWorkspacePage = lazy(() => import("@/pages/driver/driver-workspace-page").then(module => ({ default: module.DriverWorkspacePage })));

/**
 * Locale-relative route registry (paths are appended after `/:locale/`).
 * Stub entries can be replaced in place as their real pages are implemented.
 */
export interface AppRoute {
    path: string;
    element: React.ReactNode;
}

export const APP_ROUTES: AppRoute[] = [
    { path: "", element: <HomePage /> },
    { path: "products", element: <CategoriesPage /> },
    { path: "new-arrivals", element: <ProductListPage mode="new-arrivals" /> },
    { path: "special-offers", element: <ProductListPage mode="offers" /> },
    { path: "sign-in", element: <SignInPage /> },
    { path: "sign-up", element: <SignUpPage /> },
    { path: "forgot-password", element: <ForgotPasswordPage /> },
    { path: "reset-password", element: <ResetPasswordPage /> },
    { path: "reset-password-sent", element: <ResetSentPage /> },
    { path: "confirm-email", element: <ConfirmEmailPage /> },
    { path: "user-setup", element: <UserSetupPage /> },
    { path: "about", element: <AboutPage /> },
    { path: "my-cart", element: <CartPage /> },
    { path: "account-settings", element: <AccountSettingsPage /> },
    { path: "products/details/:productRef", element: <ProductDetailsPage /> },
    { path: "products/:categoryId", element: <ProductListPage mode="category" /> },
    { path: "shipping-details", element: <ShippingDetailsPage /> },
    { path: "shipping-addresses/new", element: <AddressFormPage /> },
    { path: "shipping-addresses/:shippingAddressId/edit", element: <AddressFormPage /> },
    { path: "shipping-addresses", element: <AddressesPage /> },
    { path: "my-orders", element: <OrdersPage /> },
    { path: "orders/:orderNumber", element: <OrderDetailsPage /> },
    { path: "order-confirmation/:orderNumber", element: <ConfirmationPage /> },
    { path: "payment", element: <PaymentPage /> },
    { path: "categories", element: <CategoriesPage /> },
    { path: "notifications", element: <NotificationsPage /> },
    { path: "driver", element: <DriverWorkspacePage /> }
];
